const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogFuncao`, params);
    },
    $obterRelatorioLogCSVFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeFuncaoCsv`, params);
    },
    $obterRelatorioLogPDFFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeFuncaoPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;